// @ts-strict-ignore
import { Dict } from '../../model/dict';
/**
 * Ensures that the values in the dict only contains numbers.
 * @param values
 *
 * @returns
 */
export function cleanOutcomeValues(values: Dict<string | null | number>): Dict<number> {
  const clean: Dict<number> = {};
  Object.entries(values).forEach(([key, value]) => {
    let cleaned: number | undefined;
    if (typeof value === 'number') {
      cleaned = value;
    } else {
      const parsed = parseFloat(value);
      if (!isNaN(parsed)) {
        cleaned = parsed;
      }
    }
    clean[key] = cleaned;
  });
  return clean;
}
